import { motion } from "framer-motion";
import { styled } from "styled-components";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const AnimateHeight: any = styled(motion.div)`
  overflow: hidden;
`;
